import { render, staticRenderFns } from "./DashboardSectionControlSelect.vue?vue&type=template&id=2418274e&scoped=true"
import script from "./DashboardSectionControlSelect.vue?vue&type=script&lang=js"
export * from "./DashboardSectionControlSelect.vue?vue&type=script&lang=js"
import style0 from "./DashboardSectionControlSelect.vue?vue&type=style&index=0&id=2418274e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418274e",
  null
  
)

export default component.exports